import { render, staticRenderFns } from "./shareDialog.vue?vue&type=template&id=208e8d01&scoped=true&"
import script from "./shareDialog.vue?vue&type=script&lang=js&"
export * from "./shareDialog.vue?vue&type=script&lang=js&"
import style0 from "./shareDialog.vue?vue&type=style&index=0&id=208e8d01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208e8d01",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('208e8d01')) {
      api.createRecord('208e8d01', component.options)
    } else {
      api.reload('208e8d01', component.options)
    }
    module.hot.accept("./shareDialog.vue?vue&type=template&id=208e8d01&scoped=true&", function () {
      api.rerender('208e8d01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/components/shareDialog.vue"
export default component.exports